class ZoomService
{

    currentXYDistance = 0;
    prevXPosition = 0;
    prevYPosition = 0;
    offsetX = 0;
    offsetY = 0;
    eventCache = [];
    boxKeys = ["left", "right", "top", "bottom"];

    init = ({
        initialZoom = 1,
        minZoom = 1,
        maxZoom = 5,
        scaleOnTouch = 0.03,
        scaleOnClick = 0.1,
        onTransform,
        targetObj
    }) =>
    {
        this.minZoom = minZoom;
        this.maxZoom = maxZoom;
        this.initialZoom = initialZoom;
        this.currentZoom = initialZoom;
        this.scaleOnClick = scaleOnClick;
        this.scaleOnTouch = scaleOnTouch;
        this.targetObj = targetObj;
        this.onTransform = onTransform;
    }

    hasInit = () =>
    {
        return this.minZoom &&
        this.maxZoom &&
        this.initialZoom &&
        this.currentZoom &&
        this.scaleOnClick &&
        this.scaleOnTouch &&
        this.targetObj;
    }

    getTargetObj = () => {
        return this.targetObj;
    }

    updateOffsetX = x => {
        this.offsetX = x;
    }

    updateOffsetY = y => {
        this.offsetY = y;
    }

    addEventListeners = () =>
    {
        this.targetObj.addEventListener("pointerdown", this.handlePointerDown);
        this.targetObj.addEventListener("pointermove", this.handlePointerMove);
        this.targetObj.addEventListener("pointerup", this.handlePointerUp);
        this.targetObj.addEventListener("pointercancel", this.handlePointerUp);
        this.targetObj.addEventListener("onpointerleave", this.handlePointerUp);
        this.targetObj.addEventListener("onpointerout", this.handlePointerUp);
        this.targetObj.addEventListener("wheel", this.handleZoomOnWheel);
    }

    removeEventListeners = () =>
    {
        this.targetObj.removeEventListener("pointerdown", this.handlePointerDown);
        this.targetObj.removeEventListener("pointermove", this.handlePointerMove);
        this.targetObj.removeEventListener("pointerup", this.handlePointerUp);
        this.targetObj.removeEventListener("pointercancel", this.handlePointerUp);
        this.targetObj.removeEventListener("onpointerleave", this.handlePointerUp);
        this.targetObj.removeEventListener("onpointerout", this.handlePointerUp);
        this.targetObj.removeEventListener("wheel", this.handleZoomOnWheel);
    }

    handleZoomOnTouch = (pointer1, pointer2) =>
    {
        if (typeof pointer1 === "undefined" || typeof pointer2 === "undefined") return;

        const xDistance = pointer2.clientX - pointer1.clientX;
        const yDistance = pointer2.clientY - pointer1.clientY;
        const currentXYDistance = Math.sqrt(xDistance * xDistance + yDistance * yDistance);

        if (this.prevXYDistance)
        {
            const zoomIn = currentXYDistance > this.prevXYDistance;
            const zoom = zoomIn ? this.currentZoom + this.scaleOnTouch : this.currentZoom - this.scaleOnTouch;
            const scale = this.currentZoom;

            this.updateZoom(zoom);
            if (!this.isNextZoomValueValid(zoom)) {
                this.applyTransformations();
                return;
            }

            const pointerX = (pointer1.clientX + pointer2.clientX) / 2;
            const pointerY = (pointer1.clientY + pointer2.clientY) / 2 - 70;
            const offsetX = this.offsetX + pointerX / this.currentZoom - pointerX / scale;
            const offsetY = this.offsetY + pointerY / this.currentZoom - pointerY / scale;

            this.updateOffsetX(offsetX);
            this.updateOffsetY(offsetY);
            this.handleAdjustment();
        }
        this.prevXYDistance = currentXYDistance;
    }

    handleZoomOnPanelButtons = command =>
    {
        if (command !== "in" && command !== "out" && command !== "default") return;

        const scale = this.currentZoom;
        let offsetX = this.offsetX;
        let offsetY = this.offsetY;
        if (command === "in" || command === "out")
        {
            const zoom = command === "in" ? this.currentZoom + this.scaleOnClick : this.currentZoom - this.scaleOnClick;

            this.updateZoom(zoom);
            if (!this.isNextZoomValueValid(zoom)) {
                this.applyTransformations();
                return;
            }

            const elemParent = this.targetObj.parentElement.getBoundingClientRect();
            const pointerX = elemParent.width / 2;
            const pointerY = elemParent.height / 2 - 70;
            offsetX = this.offsetX + pointerX / this.currentZoom - pointerX / scale;
            offsetY = this.offsetY + pointerY / this.currentZoom - pointerY / scale;
        }
        else
        {
            this.resetZoom();
            const zoom = this.initialZoom;

            const elemParent = this.targetObj.parentElement.getBoundingClientRect();
            const pointerX = elemParent.width / 2;
            const pointerY = elemParent.height / 2 - 70;
            offsetX = this.offsetX + pointerX / zoom - pointerX / scale;
            offsetY = this.offsetY + pointerY / zoom - pointerY / scale;
        }

        
        this.updateOffsetX(offsetX);
        this.updateOffsetY(offsetY);
        this.applyTransformations();
        this.handleAdjustment();
    }

    handleZoomOnWheel = event =>
    {
        if (!event?.deltaY || event.deltaY === 0) return;

        const scale = this.currentZoom;
        const zoom = event.deltaY < 0 ? this.currentZoom + this.scaleOnClick : this.currentZoom - this.scaleOnClick;

            this.updateZoom(zoom);
        if (!this.isNextZoomValueValid(zoom)) {
            this.applyTransformations();
            return;
        }

        const pointerX = event.clientX;
        const pointerY = event.clientY - 70;
        const offsetX = this.offsetX + pointerX / this.currentZoom - pointerX / scale;
        const offsetY = this.offsetY + pointerY / this.currentZoom - pointerY / scale;

        
        this.updateOffsetX(offsetX);
        this.updateOffsetY(offsetY);

        this.applyTransformations();
        this.handleAdjustment();
    }

    updateZoom = zoomParam => {
        const zoom = parseFloat(zoomParam.toFixed(2));
        this.currentZoom = zoom > this.minZoom ? zoom : this.minZoom;
        this.currentZoom = this.currentZoom < this.maxZoom ? this.currentZoom : this.maxZoom;
    }

    isNextZoomValueValid = zoomParam => {
        const zoom = parseFloat(zoomParam.toFixed(2));
        return zoom >= this.minZoom && zoom <= this.maxZoom;
    }

    updatePosition = (e) =>
    {
        const x1 = e && e.clientX;
        const y1 = e && e.clientY;
        if (typeof x1 !== 'undefined' && this.prevXPosition) {
            const moveToRight = x1 > this.prevXPosition;
            const x1Diff = Math.abs(x1 - this.prevXPosition);
            const offsetXVal = moveToRight ? x1Diff : -x1Diff;
            this.updateOffsetX(this.offsetX + offsetXVal / this.currentZoom);
        }
        this.prevXPosition = x1;

        if (typeof y1 !== 'undefined' && this.prevYPosition) {
            const moveUp = y1 > this.prevYPosition;
            const y1Diff = Math.abs(y1 - this.prevYPosition);
            const offsetYVal = moveUp ? y1Diff : -y1Diff;
            this.updateOffsetY(this.offsetY + offsetYVal  / this.currentZoom);
        }
        this.prevYPosition = y1;
    }

    applyTransformations = () =>
    {
        if (!this.targetObj) return;

        this.targetObj.style.setProperty("--zoom", `${this.currentZoom}`);
        this.targetObj.style.setProperty("--x", `${this.offsetX}px`);
        this.targetObj.style.setProperty("--y", `${this.offsetY}px`);

        if (typeof this.onTransform === "function") this.onTransform();
    }

    resetZoom = () =>
    {
        this.currentZoom = this.initialZoom;
    }

    resetPosition = () =>
    {
        this.updateOffsetX(0);
        this.updateOffsetY(0);
    }

    handlePointerDown = event =>
    {
        if (!event.pointerId) return;
        if (this.eventCache.length !== 2) this.eventCache.push(event);
    }

    handlePointerMove = event => {
        if (this.eventCache.length === 0) return;
        if (this.eventCache.length === 2) {
            // Find this event in the cache and update its record with this event
            for (let i = 0; i < this.eventCache.length; i++) {
                if (event.pointerId === this.eventCache[i].pointerId) {
                    this.eventCache[i] = event;
                    break;
                }
            }
            this.handleZoomOnTouch(this.eventCache[0], this.eventCache[1]);
        }
        if (this.eventCache.length === 1) this.updatePosition(event);

        this.applyTransformations();
    }

    adjustPositioning = (key) => {
        let shouldRePaint = false;
        switch (key) {
            case "left":
                if (this.offsetX > 0) {
                    this.updateOffsetX(0)
                    shouldRePaint = true;
                }
                break;
            case "right":
                if (this.targetObj.scrollWidth + this.offsetX - 10 < window.innerWidth / this.currentZoom) {
                    this.updateOffsetX(window.innerWidth / this.currentZoom - this.targetObj.scrollWidth + 10)
                    shouldRePaint = true;
                }
                break;
            case "top":
                if (this.offsetY > 0) {
                    this.updateOffsetY(0)
                    shouldRePaint = true;
                }
                break;
            case "bottom":
                const navbarHeight = 70 / this.currentZoom;
                if (this.targetObj.scrollHeight + this.offsetY < window.innerHeight / this.currentZoom - navbarHeight) {
                    this.updateOffsetY(window.innerHeight / this.currentZoom - navbarHeight - this.targetObj.scrollHeight)
                    shouldRePaint = true;
                }
                break;
            default:
                break;
        }

        return shouldRePaint;
    }

    handleAdjustment = () => {
        let shouldRePaint = false;
        this.boxKeys.forEach(boxKey => {
            shouldRePaint = this.adjustPositioning(boxKey) || shouldRePaint;
        });

        if (shouldRePaint) {
            this.targetObj.classList.add("adjusting");
            this.applyTransformations();
            setTimeout(() => this.targetObj.classList.remove("adjusting"), 250);
        };
    }

    handlePointerUp = event =>
    {
        // Remove this pointer from the cache
        this.eventCache = this.eventCache.filter(e => e.pointerId !== event.pointerId);

        // If the number of pointers down is less than two then reset currentZoom tracker
        if (this.eventCache.length < 2) this.currentXYDistance = 0; this.prevXPosition = 0; this.prevYPosition = 0;
        if (this.eventCache.length === 0) this.handleAdjustment();
    }

    handlePointerCancel = event =>
    {
        // Remove this pointer from the cache
        this.eventCache = this.eventCache.filter(e => e.pointerId !== event.pointerId);
    }
};

export default new ZoomService();